<template>
  <div>
    <div class="posts-recap" v-if="show">
      <div class="header">
        <div class="title">
          {{ $t('dash.posts.recap_title') }} 
          <span v-if="totalPost > 1">
            {{ countPost }} {{ $t('dash.posts.recap_title_count') }} {{ totalPost }}
          </span>
        </div>
        <div class="actions">
          <div class="minimize" @click="minimize"><i class="material-icons">remove</i></div>
          <div class="close" @click="close"><i class="material-icons">close</i></div>
        </div>
      </div>
      <div class="content">
        <ul class="scrollable">
          <li v-for="(item, index) in recap" :key="index" class="post" :class="item.status">
            <ul v-if="['all','instagram'].includes(item.storification)">
              <li class="status">
                <Tooltip :text="`${item.status == 'posting' ? $t('dash.posts.status.posting') : (item.status === 'scheduled' ? `${$t('dash.posts.status.scheduled')} - ${dateFormat(item.data.scheduled_date)}` : (item.status === 'error' ? `${$t('dash.posts.status.error')} - ${item.error}` : `${$t('dash.posts.status.posted')} - ${dateFormat(item.storification_date)}`))}`" position="top">
                  <img v-if="item.status == 'posting'" src="../../../assets/img/status-waiting.gif">
                  <img v-else-if="item.status == 'scheduled'" src="../../../assets/img/status-scheduled.png">
                  <img v-else-if="item.status == 'error'" src="../../../assets/img/status-error.png">
                  <img v-else src="../../../assets/img/status-posted.png">
                  &nbsp;
                </Tooltip>
              </li>
              <li class="page">
                <Tooltip :text="getPageInfoByBot(item.bot).name" position="top">
                  <page-image-avatar :page="getPageInfoByBot(item.bot)"/>
                  <span>&nbsp;</span>
                </Tooltip>
              </li>
              <li class="date">
                <span v-if="item.scheduled">{{ dateFormat(item.storification_date) }}</span>
              </li> 
              <li class="type">
                <Tooltip :text="$t('dash.posts.type.story')" position="top">
                  <span class="material-icons">smartphone</span>
                  &nbsp;
                </Tooltip>
              </li>
              <li class="content">
                {{ item.data.title }}
              </li>
              <li class="action">
                <Tooltip style="visibility: hidden" :text="getPageInfoByBot(item.bot).network === 'facebook' && item.data.typePost === 'video' ? $t('dash.posts.view.warning') : $t('dash.posts.view')" position="top" v-if="item.status == 'posted' && ['facebook', 'twitter', 'linkedin', 'pinterest', 'instagram'].includes(getPageInfoByBot(item.bot).network)">
                  <vs-button class="btnx" type="flat" 
                    @click.prevent="showPost(getPageInfoByBot(item.bot), item.pageEmbed.post_number_bis ? item.pageEmbed.post_number_bis : item.pageEmbed.post_number, item.data.videoReel)" 
                    icon="visibility"
                    :disabled="disableShowPost"
                  ></vs-button>
                  &nbsp;
                </Tooltip>
                <Tooltip style="visibility: hidden" :text="$t('dash.button.edit.post')" position="top" v-if="(item.status == 'scheduled' && !(getPageInfoByBot(item.bot).isGroup && getPageInfoByBot(item.bot).network === 'facebook')) || item.status == 'error'">
                  <vs-button class="btnx" type="flat"
                    @click.prevent="editPost(getPageInfoByBot(item.bot).id, item.data.id || item.id, item.status)" 
                    icon="edit"
                  ></vs-button>
                  &nbsp;
                </Tooltip>
                <span v-if="item.status == 'posting'">&nbsp;</span>
              </li>
            </ul>
            <ul v-if="['facebook', 'all'].includes(item.storification)">
              <li class="status">
                <Tooltip :text="`${item.status == 'posting' ? $t('dash.posts.status.posting') : (item.status === 'scheduled' ? `${$t('dash.posts.status.scheduled')} - ${dateFormat(item.data.scheduled_date)}` : (item.status === 'error' ? `${$t('dash.posts.status.error')} - ${item.error}` : `${$t('dash.posts.status.posted')} - ${dateFormat(item.storification_date)}`))}`" position="top">
                  <img v-if="item.status == 'posting'" src="../../../assets/img/status-waiting.gif">
                  <img v-else-if="item.status == 'scheduled'" src="../../../assets/img/status-scheduled.png">
                  <img v-else-if="item.status == 'error'" src="../../../assets/img/status-error.png">
                  <img v-else src="../../../assets/img/status-posted.png">
                  &nbsp;
                </Tooltip>
              </li>
              <li class="page">
                <Tooltip :text="fbAffectedBot[item.bot].name" position="top">
                  <page-image-avatar :page="fbAffectedBot[item.bot]"/>
                  <span>&nbsp;</span>
                </Tooltip>
              </li>
              <li class="date">
                <span v-if="item.scheduled">{{ dateFormat(item.storification_date) }}</span>
              </li> 
              <li class="type">
                <Tooltip :text="$t('dash.posts.type.story')" position="top">
                  <span class="material-icons">smartphone</span>
                  &nbsp;
                </Tooltip>
              </li>
              <li class="content">
                {{ item.data.title }}
              </li>
              <li class="action">
                <Tooltip style="visibility: hidden" :text="getPageInfoByBot(item.bot).network === 'facebook' && item.data.typePost === 'video' ? $t('dash.posts.view.warning') : $t('dash.posts.view')" position="top" v-if="item.status == 'posted' && ['facebook', 'twitter', 'linkedin', 'pinterest', 'instagram'].includes(getPageInfoByBot(item.bot).network)">
                  <vs-button class="btnx" type="flat" 
                    @click.prevent="showPost(getPageInfoByBot(item.bot), item.pageEmbed.post_number_bis ? item.pageEmbed.post_number_bis : item.pageEmbed.post_number, item.data.videoReel)" 
                    icon="visibility"
                    :disabled="disableShowPost"
                  ></vs-button>
                  &nbsp;
                </Tooltip>
                <Tooltip style="visibility: hidden" :text="$t('dash.button.edit.post')" position="top" v-if="(item.status == 'scheduled' && !(getPageInfoByBot(item.bot).isGroup && getPageInfoByBot(item.bot).network === 'facebook')) || item.status == 'error'">
                  <vs-button class="btnx" type="flat"
                    @click.prevent="editPost(getPageInfoByBot(item.bot).id, item.data.id || item.id, item.status)" 
                    icon="edit"
                  ></vs-button>
                  &nbsp;
                </Tooltip>
                <span v-if="item.status == 'posting'">&nbsp;</span>
              </li>
            </ul>
            <ul>
              <li class="status">
                <Tooltip v-if="item.status == 'posting'" :text="$t('dash.posts.status.posting')" position="top">
                  <img src="../../../assets/img/status-waiting.gif">
                  &nbsp;
                </Tooltip>
                <!-- <Tooltip v-else-if="item.status == 'posted' && getPageInfoByBot(item.bot).network === 'tiktok' && item.data.typePost === 'video'" :text="`${$t('dash.posts.status.uploaded')} - ${dateFormat(item.data.scheduled_date)}`" position="top">
                  <img style="width: 35px" src="../../../assets/img/status-posted-tiktok.png">
                  &nbsp;
                </Tooltip> -->
                <Tooltip v-else-if="item.status == 'posted' && getPageInfoByBot(item.bot).network === 'facebook' && item.data.typePost === 'video'" :text="`${$t('dash.posts.status.postedfb')} - ${dateFormat(item.data.scheduled_date)}`" position="top">
                  <img style="width: 35px" src="../../../assets/img/status-postedfb.png">
                  &nbsp;
                </Tooltip>
                <Tooltip v-else-if="item.status == 'posted'" :text="`${$t('dash.posts.status.posted')} - ${dateFormat(item.data.scheduled_date)}`" position="top">
                  <img src="../../../assets/img/status-posted.png">
                  &nbsp;
                </Tooltip>
                <Tooltip v-else-if="item.status == 'scheduled'" :text="`${$t('dash.posts.status.scheduled')} - ${dateFormat(item.data.scheduled_date)}`" position="top">
                  <img src="../../../assets/img/status-scheduled.png">
                  &nbsp;
                </Tooltip>
                <Tooltip v-else-if="item.status == 'error'" :text="`${$t('dash.posts.status.error')} - ${item.error}`" position="top">
                  <img src="../../../assets/img/status-error.png">
                  &nbsp;
                </Tooltip>
                <Tooltip v-else-if="item.status == 'deleting'" :text="$t('dash.posts.status.deleting')" position="top">
                  <img src="../../../assets/img/status-waiting.gif">
                  &nbsp;
                </Tooltip>
                <Tooltip v-else-if="item.status == 'deleted'" :text="`${$t('dash.posts.status.deleted')} - ${dateFormat(item.data.deleted_date)}`" position="top">
                  <img src="../../../assets/img/status-deleted.png">
                  &nbsp;
                </Tooltip>
              </li>
              <li class="page">
                <Tooltip :text="item.fbAffected ? fbAffectedBot[item.bot].name : getPageInfoByBot(item.bot).name" position="top">
                  <page-image-avatar :page="item.fbAffected ? fbAffectedBot[item.bot] : getPageInfoByBot(item.bot)"/>
                  <span>&nbsp;</span>
                </Tooltip>
              </li>
              <li class="date">
                <span v-if="item.scheduled">{{ dateFormat(item.data.scheduled_date) }}</span>
                <Tooltip v-else :text="dateFormat(item.data.scheduled_date || item.data.deleted_date)" position="top">
                  <span>{{ $t('dash.preview.date.now') }}</span>&nbsp;
                </Tooltip>
              </li> 
              <li class="type">
                <Tooltip :text="$t('dash.posts.type.video')" position="top" v-if="item.data.typePost == 'video'">
                  <span class="material-icons">videocam</span>
                  &nbsp;
                </Tooltip>
                <Tooltip :text="$t('dash.posts.type.image')" position="top" v-else-if="item.data.typePost == 'image'">
                  <span class="material-icons">image</span>
                  &nbsp;
                </Tooltip>
                <Tooltip :text="$t('dash.posts.type.snippet')" position="top" v-else-if="item.data.typePost == 'standard'">
                  <span class="material-icons">link</span>
                  &nbsp;
                </Tooltip>
                <Tooltip :text="$t('dash.posts.type.story')" position="top" v-else-if="item.data.typePost == 'story'">
                  <span class="material-icons">smartphone</span>
                  &nbsp;
                </Tooltip>
              </li>
              <li class="content">
                {{ item.data.title }}
              </li>
              <li class="action">
                <Tooltip :text="getPageInfoByBot(item.bot).network === 'facebook' && item.data.typePost === 'video' ? $t('dash.posts.view.warning') : $t('dash.posts.view')" position="top" v-if="item.status == 'posted' && ['facebook', 'twitter', 'linkedin', 'pinterest', 'instagram', 'bluesky'].includes(getPageInfoByBot(item.bot).network)">
                  <vs-button class="btnx" type="flat" 
                    @click.prevent="showPost(getPageInfoByBot(item.bot), item.pageEmbed.post_number_bis ? item.pageEmbed.post_number_bis : item.pageEmbed.post_number, item.data.videoReel)" 
                    icon="visibility"
                    :disabled="disableShowPost"
                  ></vs-button>
                  &nbsp;
                </Tooltip>
                <Tooltip :text="$t('dash.button.edit.post')" position="top" v-if="(item.status == 'scheduled' && !(getPageInfoByBot(item.bot).isGroup && getPageInfoByBot(item.bot).network === 'facebook')) || item.status == 'error'">
                  <vs-button class="btnx" type="flat"
                    @click.prevent="editPost(getPageInfoByBot(item.bot).id, item.data.id || item.id, item.status)" 
                    icon="edit"
                  ></vs-button>
                  &nbsp;
                </Tooltip>
                <span v-if="item.status == 'posting'">&nbsp;</span>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div class="posts-recap-minimize" @click="maximize" v-else>
      {{ recap.length }}
    </div>
  </div>
</template>

<script>
  import moment from 'moment'

  import PageImageAvatar from '../PageImageAvatar.vue'
  import Popup from '../../../utils/Popup'
  import Posts from '../../mixins/Posts'
  import Pages from '../../mixins/Pages'
  import Tooltip from './../tooltip/tooltipInit.vue'

  export default {
  name: 'component-posts-recap',

  mixins: [Posts, Pages],

  components: {
    PageImageAvatar,
    Tooltip
  },

  props: {
    linked: {
      type: Array,
      required: true
    },
    bots: {
      type: Array,
      required: true
    },
    recap: Array,
    show: Boolean,
    totalPost: Number,
    countPost: Number
  },

  data() {
    return {
      disableShowPost: false
    }
  },

 computed: {

    fbAffectedBot() {
      let needFb = this.recap.filter(e => e.storification === 'facebook' || e.storification === 'all');
      if (needFb.length === 0) {
        return null;
      }
      let affected = needFb.reduce((acc, e) => {
        let affected_to = this.bots.find(b => b.id === e.bot).page.affected_to;
        if (!affected_to) return null;
        let botFb = this.bots.find(b => b.page.network_id === affected_to);
        return {...acc, [e.bot]: botFb.page}
      }, {})
      return affected;
    }
  },

  methods: {

    async getTiktokPageUrl(id) {
      console.log("getTiktokPageUrl", id);
      this.getTiktokUrl(id).then(res => {
        console.log(res);
        if (res.ok && res.body.success) {
          const url = res.body.profile_deep_link;
          //open url in new tab
          Popup.open(url, '', 900, 700)
        }
      });
    },

    minimize(){
      this.$emit('minimize')
    },

    maximize(){
      this.$emit('maximize')
    },

    close(){
      this.$emit('close')
    },

    getPageInfoByBot(botId) {
      const { bots, linked } = this
      let bot = bots.find(b => b.id == botId)
      return linked.find(x => x.id === bot.page.id)
    },

    dateFormat(date){
      return moment(date).local().format('L LT')
    },

    showPost(page, postId, videoReel=false){
      switch(page.network){
        case 'facebook':
          this.openFacebook(postId, videoReel)
          break
        case 'twitter': 
          this.openTweet(page.name, postId)
          break
        case 'linkedin': 
          this.openLinkedin(page.id, postId)
          break
        case 'pinterest':
          this.openPinterest(postId)
          break
        case 'instagram':
          this.openInstagram(page.name)
          break
        case 'tiktok':
          this.getTiktokPageUrl(page.id)
          break
        case 'bluesky':
          this.openBluesky(page.name, postId)
          break
        default:
      }
    },

    openBluesky(username, post_number) {
      Popup.open(`https://bsky.app/profile/${username}/post/${post_number.split('/').pop()}`, '', 900, 700)
    },

    openInstagram(username){
      Popup.open(`https://www.instagram.com/${username}`, '', 900, 700)
    },

    openTweet(username, postId){
      Popup.open(`https://www.twitter.com/${username}/status/${postId}`, '', 900, 700)
    },

    openLinkedin(pageId, postId) {
      console.log(pageId, postId);
      if (postId.includes('urn:li:activity:')) {
        Popup.open(`https://www.linkedin.com/feed/update/${postId}`, '', 900, 700)
      } else {
        this.disableShowPost = true
        this.getLinkedinPost(pageId, postId).then(async res => {
          this.disableShowPost = false
          const { success, post } = res.body
          if(success && post && post.activity)
            Popup.open(`https://www.linkedin.com/feed/update/${post.activity}`, '', 900, 700)
          else if(success && post && post.id)
            Popup.open(`https://www.linkedin.com/feed/update/${post.id}`, '', 900, 700)
        })
      }
    },

    openFacebook(postId, videoReel=false) {
      Popup.open(`https://www.facebook.com/${videoReel ? 'reel/' : ''}${postId}`, '', 900, 700)
    },

    openPinterest(postId){
      Popup.open(`https://www.pinterest.fr/pin/${postId}`, '', 900, 700)
    },

    editPost(page, id, status){
      console.log("editPost", page, id, status)
      if(status == "scheduled") this.$emit('edit', page, id, "scheduled")
      else if(status == "error") this.$emit('edit', page, id, "inqueue")
    },
  }
}
</script>
